import React, { useState } from "react";
import { Dropdown } from "antd";
import TradeTable from "./TradeTable";
import {
  SearchOutlined,
  CheckCircleFilled,
  UserOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";
import { Col, Row } from "antd";
import { useLayout } from "../Context/LayoutContext";
import { motion, AnimatePresence } from "framer-motion";

const LayoutDrop = ({ children }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { switchLayout, activeLay, isRunning } = useLayout();
  const [animateKey, setAnimateKey] = useState(0);
  const dropdownVariants = {
    hidden: {
      opacity: 0,
      rotateX: -90,
      transformOrigin: "top center",
      y: -20,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      rotateX: 0,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.45,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.08,
      },
    },
    exit: {
      opacity: 0,
      rotateX: -90,
      y: -10,
      scale: 0.95,
      transition: { duration: 0.3, ease: "easeIn" },
    },
  };

  const colVariants = {
    hidden: { opacity: 0, y: 10, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1 },
  };

  const handleDropdownChange = () => {
    if (dropdownVisible) {
      setAnimateKey((prev) => prev + 1);
    }
    setDropdownVisible(!dropdownVisible);
  };
  const customPanel = (
    <AnimatePresence mode="wait">
      {dropdownVisible && (
        <motion.div
          key={animateKey}
          variants={dropdownVariants}
          initial="hidden"
          animate="visible"
          // exit="exit"
          style={{
            background: "var(--bg-mn)",
            overflow: "hidden",
            borderRadius: 8,
            transformOrigin: "top center",
            border: "2px solid #f7a60047",
            perspective: 1000,
          }}
        >
          <motion.div className="layout-change">
            <div className="layout-h-txt">Chart Grids</div>

            <div className="p-20">
              <Row style={{ alignItems: "center" }} gutter={[16, 16]}>
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>
                      <div className="lay-typ ar3">1 chart</div>
                    </Col>
                    <Col span={3}>
                      <div>
                        <div
                          className={`${activeLay === "1c" ? "active d-flex" : "d-flex"
                            } grid-layout-box`}
                          onClick={() => {
                            switchLayout("1c");
                            setDropdownVisible(!dropdownVisible);

                          }}
                        >
                          <svg
                            width="29"
                            height="24"
                            viewBox="0 0 29 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="29"
                              height="24"
                              rx="2"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </motion.div>
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Divider
                    style={{ margin: "0px 0px", background: "#2D3343" }}
                  />
                </motion.div>
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>
                      <div className="lay-typ ar3">2 chart</div>
                    </Col>
                    <Col span={14}>
                      <div className="display-1 gap-15">
                        <div
                          className={`${activeLay === "2c-l1" ? "active d-flex" : "d-flex"
                            } grid-layout-box`}
                          onClick={() => switchLayout("2c-l1")}
                        >
                          <svg
                            width="30"
                            height="27"
                            viewBox="0 0 30 27"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="14"
                              height="27"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              x="16"
                              width="14"
                              height="27"
                              rx="2"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`${activeLay === "2c-l2" ? "active d-flex" : "d-flex"
                            } grid-layout-box`}
                          onClick={() => switchLayout("2c-l2")}
                        >
                          <svg
                            width="29"
                            height="30"
                            viewBox="0 0 29 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="29.9999"
                              width="14"
                              height="29"
                              rx="2"
                              transform="rotate(-90 0 29.9999)"
                              fill="#8E9199"
                            />
                            <rect
                              y="13.9999"
                              width="14"
                              height="29"
                              rx="2"
                              transform="rotate(-90 0 13.9999)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </motion.div>
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Divider
                    style={{ margin: "0px 0px", background: "#2D3343" }}
                  />
                </motion.div>{" "}
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>
                      <div className="lay-typ ar3">3 chart</div>
                    </Col>
                    <Col span={14}>
                      <div className="display-1 gap-15">
                        <div
                          className={`${activeLay === "3c-l1" ? "active d-flex" : "d-flex"
                            } grid-layout-box`}
                          onClick={() => switchLayout("3c-l1")}
                        >
                          <svg
                            width="29"
                            height="29"
                            viewBox="0 0 29 29"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="28"
                              width="14"
                              height="27"
                              rx="2"
                              transform="rotate(90 28 0)"
                              fill="#8E9199"
                            />
                            <rect
                              x="14"
                              y="16"
                              width="13"
                              height="14"
                              rx="2"
                              transform="rotate(90 14 16)"
                              fill="#8E9199"
                            />
                            <rect
                              x="29"
                              y="16"
                              width="13"
                              height="14"
                              rx="2"
                              transform="rotate(90 29 16)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`grid-layout-box ${activeLay === "3c-l2" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("3c-l2")}
                        >
                          <svg
                            width="31"
                            height="31"
                            viewBox="0 0 31 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.779053"
                              width="14.6341"
                              height="12.9124"
                              rx="1.72166"
                              fill="#8E9199"
                            />
                            <rect
                              y="16.2739"
                              width="30.9899"
                              height="13.7733"
                              rx="1.72166"
                              fill="#8E9199"
                            />
                            <rect
                              x="16.3594"
                              y="0.778931"
                              width="14.6341"
                              height="12.9124"
                              rx="1.72166"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>

                        <div
                          className={`grid-layout-box ${activeLay === "3c-l4" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("3c-l4")}
                        >
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="13.9999"
                              width="14"
                              height="14"
                              rx="2"
                              transform="rotate(-90 0 13.9999)"
                              fill="#8E9199"
                            />
                            <rect
                              y="30"
                              width="14"
                              height="14"
                              rx="2"
                              transform="rotate(-90 0 30)"
                              fill="#8E9199"
                            />
                            <rect
                              x="16"
                              y="30"
                              width="30"
                              height="14"
                              rx="2"
                              transform="rotate(-90 16 30)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>

                        <div
                          className={`grid-layout-box ${activeLay === "3c-l3" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("3c-l3")}
                        >
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="14"
                              height="14"
                              rx="2"
                              transform="matrix(0 -1 -1 0 30 13.9999)"
                              fill="#8E9199"
                            />
                            <rect
                              width="14"
                              height="14"
                              rx="2"
                              transform="matrix(0 -1 -1 0 30 30)"
                              fill="#8E9199"
                            />
                            <rect
                              width="30"
                              height="14"
                              rx="2"
                              transform="matrix(0 -1 -1 0 14 30)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`grid-layout-box ${activeLay === "3c-l5" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("3c-l5")}
                        >
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="25"
                              height="7"
                              rx="2"
                              transform="matrix(0 -1 -1 0 7 25)"
                              fill="#8E9199"
                            />
                            <rect
                              width="25"
                              height="7"
                              rx="2"
                              transform="matrix(0 -1 -1 0 16 25)"
                              fill="#8E9199"
                            />
                            <rect
                              width="25"
                              height="7"
                              rx="2"
                              transform="matrix(0 -1 -1 0 25 25)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </motion.div>
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Divider
                    style={{ margin: "0px 0px", background: "#2D3343" }}
                  />
                </motion.div>{" "}
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>
                      <div className="lay-typ ar3">4 chart</div>
                    </Col>
                    <Col span={14}>
                      <div className="display-1 gap-15">
                        <div
                          className={`grid-layout-box ${activeLay === "4c-l1" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => {
                            switchLayout("4c-l1");
                            setDropdownVisible(!dropdownVisible);

                          }}
                        >
                          <svg
                            width="31"
                            height="27"
                            viewBox="0 0 31 27"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="14"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              x="17"
                              width="14"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              y="15"
                              width="14"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              x="17"
                              y="15"
                              width="14"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`grid-layout-box ${activeLay === "4c-l2" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("4c-l2")}
                        >
                          <svg
                            width="30"
                            height="27"
                            viewBox="0 0 30 27"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width="8" height="12" rx="2" fill="#8E9199" />
                            <rect
                              x="11"
                              width="8"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              x="22"
                              width="8"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              y="15"
                              width="30"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`grid-layout-box ${activeLay === "4c-l3" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("4c-l3")}
                        >
                          <svg
                            width="30"
                            height="28"
                            viewBox="0 0 30 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="16.0001"
                              width="8"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              x="11"
                              y="16.0001"
                              width="8"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              x="22"
                              y="16.0001"
                              width="8"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                            <rect
                              y="0.00012207"
                              width="30"
                              height="12"
                              rx="2"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`grid-layout-box ${activeLay === "4c-l4" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("4c-l4")}
                        >
                          <svg
                            width="28"
                            height="30"
                            viewBox="0 0 28 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="16"
                              y="30.0003"
                              width="8"
                              height="12"
                              rx="2"
                              transform="rotate(-90 16 30.0003)"
                              fill="#8E9199"
                            />
                            <rect
                              x="16"
                              y="19.0001"
                              width="8"
                              height="12"
                              rx="2"
                              transform="rotate(-90 16 19.0001)"
                              fill="#8E9199"
                            />
                            <rect
                              x="16"
                              y="7.99982"
                              width="8"
                              height="12"
                              rx="2"
                              transform="rotate(-90 16 7.99982)"
                              fill="#8E9199"
                            />
                            <rect
                              y="30"
                              width="30"
                              height="12"
                              rx="2"
                              transform="rotate(-90 0 30)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                        <div
                          className={`grid-layout-box ${activeLay === "4c-l5" ? "active d-flex" : "d-flex"
                            }`}
                          onClick={() => switchLayout("4c-l5")}
                        >
                          <svg
                            width="28"
                            height="30"
                            viewBox="0 0 28 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="8"
                              height="12"
                              rx="2"
                              transform="matrix(0 -1 -1 0 12 30.0003)"
                              fill="#8E9199"
                            />
                            <rect
                              width="8"
                              height="12"
                              rx="2"
                              transform="matrix(0 -1 -1 0 12 19.0001)"
                              fill="#8E9199"
                            />
                            <rect
                              width="8"
                              height="12"
                              rx="2"
                              transform="matrix(0 -1 -1 0 12 7.99982)"
                              fill="#8E9199"
                            />
                            <rect
                              width="30"
                              height="12"
                              rx="2"
                              transform="matrix(0 -1 -1 0 28 30)"
                              fill="#8E9199"
                            />
                          </svg>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </motion.div>
                <motion.div variants={colVariants} style={{ width: "100%" }}>
                  <Divider
                    style={{ margin: "0px 0px", background: "#2D3343" }}
                  />
                </motion.div>{" "}
                {/* <Col span={10}>
                        <div className='lay-typ'>
                            More grids
                        </div>
                    </Col> */}
                {/* <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "mc-l1" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l1")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" width="30" height="17" rx="2" fill="#8E9199" />
                                    <rect y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                    <rect x="8" y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                    <rect x="16" y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                    <rect x="24" y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l2" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l2")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="8" width="23" height="27" rx="2" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                    <rect y="14.4" width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                    <rect y="7.20001" width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                    <rect y="21.6" width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "mc-l3" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l3")}>


                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="23" height="27" rx="2" transform="matrix(-1 0 0 1 23 0)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 0)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 14.4)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 7.20001)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 21.6)" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l4" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l4")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="19" height="17" rx="2" transform="matrix(-1 0 0 1 19 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.168 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.168 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.168 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 19.168 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.16797 20)" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "mc-l5" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l5")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 9 12)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 20 12)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 31 12)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 9 27)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 20 27)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 31 27)" fill="#8E9199" />
                                </svg>

                            </div>


                        </div>
                    </Col> */}
                {/* <Divider style={{ margin: "0px 0px", background: "#2D3343" }} /> */}
                {/* <Col span={10}>
                        
                    </Col> */}
                {/* <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "mc-l6" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l6")}>

                                <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect y="16" width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect x="17" width="13" height="5" rx="2" fill="#8E9199" />
                                    <rect x="17" y="7" width="13" height="5" rx="2" fill="#8E9199" />
                                    <rect x="17" y="16" width="13" height="5" rx="2" fill="#8E9199" />
                                    <rect x="17" y="23" width="13" height="5" rx="2" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l7" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l7")}>


                                <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="12" rx="2" transform="matrix(-1 0 0 1 30 0)" fill="#8E9199" />
                                    <rect width="14" height="12" rx="2" transform="matrix(-1 0 0 1 30 16)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 0)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 7)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 16)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 23)" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l8" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l8")}>

                                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="13" height="12" rx="2" fill="#8E9199" />
                                    <rect x="17" width="13" height="12" rx="2" fill="#8E9199" />
                                    <rect x="1" y="15" width="7" height="12" rx="2" fill="#8E9199" />
                                    <rect x="11" y="15" width="7" height="12" rx="2" fill="#8E9199" />
                                    <rect x="21" y="15" width="7" height="12" rx="2" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "mc-l9" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l9")}>
                                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="13" height="12" rx="2" transform="matrix(1 0 0 -1 0 27)" fill="#8E9199" />
                                    <rect width="13" height="12" rx="2" transform="matrix(1 0 0 -1 17 27)" fill="#8E9199" />
                                    <rect width="7" height="12" rx="2" transform="matrix(1 0 0 -1 1 12)" fill="#8E9199" />
                                    <rect width="7" height="12" rx="2" transform="matrix(1 0 0 -1 11 12)" fill="#8E9199" />
                                    <rect width="7" height="12" rx="2" transform="matrix(1 0 0 -1 21 12)" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l10" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l10")}>


                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.17188 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 18.1719 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.1719 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.17188 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 18.1719 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.1719 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.17188 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 18.1719 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.1719 20)" fill="#8E9199" />
                                </svg>
                            </div>
                        </div>
                    </Col> */}
              </Row>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return (
    <Dropdown
      overlay={customPanel}
      trigger={[!isRunning && "click"]}
      overlayStyle={{
        borderRadius: "16px",
        // boxShadow: "0 4px 32px rgba(0,0,0,0.35)",
        // background: "#212738",
      }}
      open={dropdownVisible}
      onOpenChange={handleDropdownChange}
    >
      {children}
    </Dropdown>
  );
};

export default LayoutDrop;
